import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import classNames from "classnames";
import { useFormikContext } from "formik";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { cuideoTheme } from "../../../../../containers/themes/defaultTheme";
import { TServiceEditValuationForm } from "../models/ServiceEditValuationForm/ServiceEditValuationForm";
import ChangeUsersDialog, {
  TChangeUsersDialogState,
} from "./ChangeUsersDialog";

const StyledFormControl = styled(FormControl)`
  .MuiFormLabel-root {
    font-size: 0.8rem;
    padding: 0.2rem 0 0.2rem 0;
    color: ${cuideoTheme.palette.primary.light};
    white-space: wrap;
    margin: 0.125rem 0;
  }

  .MuiFormControlLabel-root {
    border-radius: ${cuideoTheme.shape.borderRadius}px;
    height: 2.5rem;
    box-sizing: border-box;
    box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.24);
    color: ${cuideoTheme.palette.text.secondary};
    background-color: ${cuideoTheme.palette.common.white};
    border: 1px solid #c2d1da;
    width: 100%;
    margin: 0.0625rem 0 0 0;
    .MuiTypography-body1 {
      font-size: 0.9rem;
      line-height: 1.2;
      font-weight: 400;
    }
    .MuiSvgIcon-root {
      height: 1rem;
      width: 1rem;
    }

    &.CMui-selected {
      background-color: #dcf1f2;
      border: 1px solid ${cuideoTheme.palette.secondary.main};
      & .MuiTypography-body1 {
        font-weight: 700;
      }
    }
  }
`;

interface IUsersToTakeCareRadioGroupProps {}

const UsersToTakeCareRadioGroup: React.FC<IUsersToTakeCareRadioGroupProps> = (
  props
) => {
  const [changeUsersDialogState, setChangeUsersDialogState] =
    useState<TChangeUsersDialogState>({
      open: false,
      user1: {
        name: "",
        surname: "",
      },
      user2: {
        name: "",
        surname: "",
      },
      selected: 1,
    });
  const formikContext = useFormikContext<TServiceEditValuationForm>();

  const handleDialogClose = () => {
    setChangeUsersDialogState((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue === "1") {
      if (hasSecondUserData()) {
        setChangeUsersDialogState((prevState) => ({
          ...prevState,
          open: true,
          selected: 1,
          user1: {
            name: formikContext.values.Nombre_U1,
            surname: formikContext.values.Primer_apellido_U1,
          },
          user2: {
            name: formikContext.values.Nombre_U2,
            surname: formikContext.values.Primer_apellido_U2,
          },
        }));
      } else {
        changeToOneUserMantainingFirst();
      }
    } else {
      formikContext.setFieldValue("Usuarios_a_cuidar", "2");
    }
  };

  const handleSelectedChange = (selected: 1 | 2) => {
    setChangeUsersDialogState((prevState) => ({
      ...prevState,
      selected,
    }));
  };

  const hasSecondUserData = (): boolean => {
    if (
      formikContext.values.Nombre_U2 !== "" ||
      formikContext.values.Primer_apellido_U2 !== "" ||
      formikContext.values.Segundo_apellido_U2 !== ""
    ) {
      return true;
    }

    return false;
  };

  const changeToOneUserMantainingFirst = () => {
    formikContext.setValues((prevValues) => ({
      ...prevValues,
      Usuarios_a_cuidar: "1",
      Estado_U2: null,
      Nombre_U2: "",
      Primer_apellido_U2: "",
      Segundo_apellido_U2: "",
      Fecha_de_nacimiento_U2: null,
      DNI_U2: "",
      DNI_U2_used_by: null,
      Patologias_U2: [],
      Comentarios_patologias_U2: "",
      Medicacion_U2: "",
      Dieta_U2: "",
      Habla_expresion_U2: "",
      Peso_U2: "",
      Altura_U2: "",
      Movilidad_U2: [],
      Comentarios_movilidad_U2: "",
      Estado_emocional_y_caracter_U2: [],
      Adaptaci_n_de_cuidados_U2: "",
      Comentarios_estado_emocional_y_caracter_U2: "",
      Actividades_y_aficiones_U2: "",
      Calidad_del_sue_o_U2: null,
      Aseo_U2: [],
      Indicaciones_del_sueno_U2: "",
      Indicaciones_del_aseo_U2: "",
    }));
  };

  const changeToOneUserMantainingSecond = () => {
    formikContext.setValues((prevValues) => ({
      ...prevValues,
      Usuarios_a_cuidar: "1",

      Estado_U1: prevValues.Estado_U2,
      Nombre_U1: prevValues.Nombre_U2,
      Primer_apellido_U1: prevValues.Primer_apellido_U2,
      Segundo_apellido_U1: prevValues.Segundo_apellido_U2,
      Fecha_de_nacimiento_U1: prevValues.Fecha_de_nacimiento_U2,
      DNI_U1: prevValues.DNI_U2,
      DNI_U1_used_by: prevValues.DNI_U2_used_by,
      Patologias_U1: prevValues.Patologias_U2,
      Comentarios_patologias_U1: prevValues.Comentarios_patologias_U2,
      Medicacion_U1: prevValues.Medicacion_U2,
      Dieta: prevValues.Dieta_U2,
      Habla_expresion_U1: prevValues.Habla_expresion_U2,
      Peso_U1: prevValues.Peso_U2,
      Altura_U1: prevValues.Altura_U2,
      Movilidad_U1: prevValues.Movilidad_U2,
      Comentarios_movilidad_U1: prevValues.Comentarios_movilidad_U2,
      Estado_emocional_y_caracter_U1: prevValues.Estado_emocional_y_caracter_U2,
      Adaptaci_n_de_cuidados_U1: prevValues.Adaptaci_n_de_cuidados_U2,
      Comentarios_estado_emocional_y_caracter_U1:
        prevValues.Comentarios_estado_emocional_y_caracter_U2,
      Actividades_y_aficiones_U1: prevValues.Actividades_y_aficiones_U2,
      Calidad_del_sue_o_U1: prevValues.Calidad_del_sue_o_U2,
      Aseo_U1: prevValues.Aseo_U2,
      Indicaciones_del_sueno_U1: prevValues.Indicaciones_del_sueno_U2,
      Indicaciones_del_aseo_U1: prevValues.Indicaciones_del_aseo_U2,

      Estado_U2: null,
      Nombre_U2: "",
      Primer_apellido_U2: "",
      Segundo_apellido_U2: "",
      Fecha_de_nacimiento_U2: null,
      DNI_U2: "",
      DNI_U2_used_by: null,
      Patologias_U2: [],
      Comentarios_patologias_U2: "",
      Medicacion_U2: "",
      Dieta_U2: "",
      Habla_expresion_U2: "",
      Peso_U2: "",
      Altura_U2: "",
      Movilidad_U2: [],
      Comentarios_movilidad_U2: "",
      Estado_emocional_y_caracter_U2: [],
      Adaptaci_n_de_cuidados_U2: "",
      Comentarios_estado_emocional_y_caracter_U2: "",
      Actividades_y_aficiones_U2: "",
      Calidad_del_sue_o_U2: null,
      Aseo_U2: [],
      Indicaciones_del_sueno_U2: "",
      Indicaciones_del_aseo_U2: "",
    }));
  };

  const handleChangeConfirm = () => {
    if (changeUsersDialogState.selected === 2) {
      changeToOneUserMantainingSecond();
    } else {
      changeToOneUserMantainingFirst();
    }

    setChangeUsersDialogState((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  return (
    <StyledFormControl fullWidth>
      <FormLabel>
        <FormattedMessage
          id="ServiceValuationForm.NumUsers"
          defaultMessage="Usuarios a cuidar"
        />
      </FormLabel>
      <RadioGroup onChange={handleRadioChange}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={6}>
            <FormControlLabel
              value="1"
              label="1"
              control={
                <Radio
                  color="primary"
                  checked={formikContext.values.Usuarios_a_cuidar === "1"}
                />
              }
              className={classNames({
                "CMui-selected": formikContext.values.Usuarios_a_cuidar === "1",
              })}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              value="2"
              label="2"
              control={
                <Radio
                  color="primary"
                  checked={formikContext.values.Usuarios_a_cuidar === "2"}
                />
              }
              className={classNames({
                "CMui-selected": formikContext.values.Usuarios_a_cuidar === "2",
              })}
            />
          </Grid>
        </Grid>
      </RadioGroup>
      <ChangeUsersDialog
        state={changeUsersDialogState}
        onClose={handleDialogClose}
        onSelectedChange={handleSelectedChange}
        onConfirm={handleChangeConfirm}
      />
    </StyledFormControl>
  );
};

export default UsersToTakeCareRadioGroup;
